import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import colis_service from "../../services/colis-service";

const Update_colis = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const [message, setMessage] = useState({ text: "", type: "" });
  const [formData, setFormData] = useState({
    client_code: "",
    user_name: "",
    colis_number: "",
    weight: "",
    dimension: "",
    price: "",
    sending_option: "",
    status: "",
    departure_date: "",
    arrival_date: "",
  });

  useEffect(() => {
    const fetchColis = async () => {
      try {
        const response = await colis_service.getById(id);
        //console.log(response)
        const colis = response.data;
        
        const formatDateForInput = (dateString) => {
          if (!dateString) return "";
          const date = new Date(dateString);
          return date.toISOString().split('T')[0];
        };

        setFormData({
          client_code: colis.client_code || "",
          user_name: colis.user_name || "",
          colis_number: colis.colis_number || "",
          weight: colis.weight || "",
          dimension: colis.dimension || "",
          price: colis.price || "",
          sending_option: colis.sending_option || "Aérien_Normal",
          status: colis.status || "Expédié",
          departure_date: formatDateForInput(colis.departure_date),
          arrival_date: formatDateForInput(colis.arrival_date),
        });
      } catch (error) {
        setMessage({
          text: `Erreur lors du chargement des données: ${error.message || "Une erreur est survenue"}`,
          type: "danger"
        });
      } finally {
        setLoading(false);
      }
    };

    if (id) {
      fetchColis();
    } else {
      setLoading(false);
      setMessage({ text: "ID du colis manquant", type: "danger" });
    }
  }, [id]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    
    try {
      await colis_service.update(id, formData);
      
      setMessage({
        text: "Colis modifié avec succès!",
        type: "success"
      });
      
      setTimeout(() => {
        navigate('/admin');
      }, 2000);
      
    } catch (error) {
      setMessage({
        text: `Erreur lors de la mise à jour: ${error.response?.data?.message || error.message || "Une erreur est survenue"}`,
        type: "danger"
      });
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <div className="container-fluid d-flex justify-content-center align-items-center" style={{ height: '70vh' }}>
        <div className="spinner-border text-primary" role="status">
          <span className="visually-hidden">Chargement...</span>
        </div>
      </div>
    );
  }

  return (
    <div className='container-fluid full-height'>
      <h2 className="text-center text-primary fw-bold mb-3">MODIFIER UN COLIS</h2>
      
      {message.text && (
        <div className={`alert alert-${message.type} alert-dismissible fade show`} role="alert">
          {message.text}
          <button
            type="button"
            className="btn-close"
            onClick={() => setMessage({ text: "", type: "" })}
          ></button>
        </div>
      )}
      
      <form className="p-4 shadow-lg rounded bg-light" onSubmit={handleSubmit}>
        <div className="row">
          {/* Code Client */}
          <div className="col-md-6 mb-3">
            <label className="form-label">Code Client</label>
            <input 
              type="text" 
              className="form-control" 
              name="client_code"
              value={formData.client_code}
              onChange={handleChange}
              required 
            />
          </div>
          
          {/* Nom */}
          <div className="col-md-6 mb-3">
            <label className="form-label">Nom</label>
            <input 
              type="text" 
              className="form-control" 
              name="user_name"
              value={formData.user_name}
              onChange={handleChange}
              required 
            />
          </div>
          
          {/* Numéro de colis */}
          <div className="col-md-6 mb-3">
            <label className="form-label">Numéro de Colis</label>
            <input 
              type="text" 
              className="form-control" 
              name="colis_number"
              value={formData.colis_number}
              onChange={handleChange}
              required 
            />
          </div>
          
          {/* Poids */}
          <div className="col-md-6 mb-3">
            <label className="form-label">Poids (kg)</label>
            <input 
              type="text" 
              className="form-control" 
              name="weight"
              value={formData.weight}
              onChange={handleChange}
              required 
            />
          </div>
          
          {/* Dimensions */}
          <div className="col-md-6 mb-3">
            <label className="form-label">Dimensions</label>
            <input 
              type="text" 
              className="form-control" 
              name="dimension"
              value={formData.dimension}
              onChange={handleChange}
              required 
            />
          </div>
          
          {/* Prix */}
          <div className="col-md-6 mb-3">
            <label className="form-label">Prix (Ar)</label>
            <input 
              type="text" 
              className="form-control" 
              name="price"
              value={formData.price}
              onChange={handleChange}
              required 
            />
          </div>
          
          {/* Mode d'envoi */}
          <div className="col-md-6 mb-3">
            <label className="form-label">Mode d'Envoi</label>
            <select 
              className="form-select" 
              name="sending_option"
              value={formData.sending_option}
              onChange={handleChange}
              required
            >
              <option value="Aérien_Normal">Aérien normal</option>
              <option value="Aérien_Express">Aérien express</option>
              <option value="Envoi_Maritime">Envoi Maritime</option>
            </select>
          </div>
          
          {/* Status */}
          <div className="col-md-6 mb-3">
            <label className="form-label">Statut</label>
            <select 
              className="form-select" 
              name="status"
              value={formData.status}
              onChange={handleChange}
              required
            >
              <option value="Expédié">Expédié</option>
              <option value="Arrivé">Arrivé</option>
              <option value="Récupéré">Récupéré</option>
            </select>
          </div>
          
          {/* Date de départ */}
          <div className="col-md-6 mb-3">
            <label className="form-label">Date de Départ</label>
            <input 
              type="date" 
              className="form-control" 
              name="departure_date"
              value={formData.departure_date}
              onChange={handleChange}
              required 
            />
          </div>
          
          {/* Date d'arrivée */}
          <div className="col-md-6 mb-3">
            <label className="form-label">Date d'Arrivée</label>
            <input 
              type="date" 
              className="form-control" 
              name="arrival_date"
              value={formData.arrival_date}
              onChange={handleChange}
              required 
            />
          </div>
        </div>
        <div className="text-center">
          <button 
            type="submit" 
            className="btn btn-primary px-4"
            disabled={loading}
          >
            {loading ? "Chargement..." : "Modifier"}
          </button>
        </div>
      </form>
    </div>
  );
};

export default Update_colis;